import moment from 'moment';

export default function timeCount(startDate: any, showText = true) {
  return moment(startDate).locale('ru').fromNow(showText);
}
